import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  UpsertContractUpliftCaps,
  UpsertContractUpliftCapsVariables,
  UpsertUpliftCapInput
} from '../upliftCaps.types';
// TODO: Replace with codegen imports once available
import UpsertContractUpliftCapsMutation
  from '@/graphql/contracts/upsertContractUpliftCaps.mutation.gql';
import GetContractUpliftCapsQuery from '@/graphql/contracts/getContractUpliftCaps.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export interface UpsertUpliftCapsInput {
  existingUpliftCap: UpsertUpliftCapInput | null;
  furtherUpliftCap: UpsertUpliftCapInput | null;
}

export default function useUpsertContractUpliftCaps(contractId: string) {
  const [_upsertCaps, { loading }] = useMutation<
  UpsertContractUpliftCaps,
  UpsertContractUpliftCapsVariables
  >(
    UpsertContractUpliftCapsMutation,
    {
      client: apolloClientContracts,
      refetchQueries: [
        {
          query: GetContractUpliftCapsQuery,
          variables: { contractId }
        }
      ],
      awaitRefetchQueries: true,
      onCompleted: () => notificationService.open({
        title: 'Update Uplift Caps',
        text: 'Contract Uplift Caps successfully updated',
        type: 'success'
      }),
    },
  );

  const upsertContractUpliftCaps = async (
    input: UpsertUpliftCapsInput,
    cbOnError?: () => void
  ) => {
    _upsertCaps({
      variables: {
        input: {
          contractId,
          ...input
        }
      },
      onError: (err) => {
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        });

        cbOnError?.();
      }
    });
  };

  return {
    upsertContractUpliftCaps,
    isLoadingUpsert: loading
  } as const;
}
